module.exports = {"411371060":"张衡街道","411371061":"百里奚街道","411371401":"高新区产业集聚工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411371.json
// module id = 1650
// module chunks = 0